import angular from 'angular';
import modalComponent from './modalComponent';
import modalService from './modalService';

import 'angular-ui-router';
import 'angular-ui-router-title';
import 'components/sharpr/html/bindHtml/bindHtmlModule';
import 'components/sharpr/fullscreen/fullscreenModule';
import 'components/sharpr/videoPlayer/videoPlayerModule';

angular
	.module('sh.modal', ['sh.fullscreen', 'sh.videoPlayer', 'sh.bindHtml', 'ui.router', 'sh.eventTracker'])
	.directive('shModal', modalComponent)
	.service('modal', modalService);
